/* SealPod — thème Shopify · scripts (sans dépendance) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cfg = window.SealPodConfig || { currency: 'EUR', routes: { cart: '/cart', add: '/cart/add', change: '/cart/change' }, freeShip: 3500 };
  var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: cfg.currency || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + cfg.currency; }
  }
  var ICON = {
    bag: '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M16 10a4 4 0 0 1-8 0"/><path d="M3.103 6.034h17.794"/><path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"/></svg>',
    minus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    plus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14M12 5v14"/></svg>'
  };

  /* ---------------- Panier (tiroir AJAX) ---------------- */
  var Cart = {
    data: null,
    upsell: null,
    init: function () {
      var u = $('#cart-upsell');
      if (u) { try { Cart.upsell = JSON.parse(u.textContent); } catch (e) {} }
    },
    refresh: function () {
      return fetch(cfg.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { Cart.data = d; Cart.render(); return d; });
    },
    add: function (form) {
      return fetch(cfg.routes.add + '.js', {
        method: 'POST', body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      }).then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || "Impossible d'ajouter ce produit.");
        return Cart.refresh();
      }).then(function () { Cart.open(); });
    },
    addId: function (id) {
      return fetch(cfg.routes.add + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function () { return Cart.refresh(); });
    },
    change: function (line, qty) {
      return fetch(cfg.routes.change + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (d) { Cart.data = d; Cart.render(); });
    },
    open: function () {
      var dr = $('[data-drawer]'); if (!dr) return;
      dr.hidden = false;
      requestAnimationFrame(function () { dr.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var c = $('[data-drawer-close].icon-btn', dr); if (c) c.focus();
    },
    close: function () {
      var dr = $('[data-drawer]'); if (!dr) return;
      dr.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { if (!dr.classList.contains('is-open')) dr.hidden = true; }, 420);
    },
    render: function () {
      var d = Cart.data; if (!d) return;
      $$('[data-cart-count]').forEach(function (el) { el.textContent = d.item_count; el.hidden = !d.item_count; });
      var body = $('[data-drawer-body]'), foot = $('[data-drawer-foot]');
      if (!body) return;
      var thr = (cfg.freeShip || 0) * rate, msg = $('[data-ship-msg]'), fill = $('[data-ship-fill]'), ship = $('[data-ship]');
      if (ship) {
        ship.hidden = !thr;
        if (thr) {
          var left = Math.max(0, thr - d.total_price);
          msg.innerHTML = left > 0 ? 'Plus que <b>' + money(left) + '</b> pour la livraison express offerte' : '<span style="color:#047857;font-weight:500">Livraison express offerte débloquée</span>';
          fill.style.width = Math.min(100, d.total_price / thr * 100) + '%';
        }
      }
      if (!d.items.length) {
        body.innerHTML = '<div class="dl-empty">' + ICON.bag + '<p>Votre panier est vide.</p></div>';
        foot.hidden = true; return;
      }
      var html = '<ul>' + d.items.map(function (it, i) {
        var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160') + '" alt="" width="72" height="72" loading="lazy">' : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="dl-sub">' + esc(it.variant_title) + '</p>' : '';
        var was = it.original_line_price !== it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
        return '<li class="dl">' + img + '<div class="dl-info"><div class="dl-top"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a><span style="text-align:right">' + was + money(it.final_line_price) + '</span></div>' + variant +
          '<div class="dl-qty"><button type="button" data-dec="' + (i + 1) + '" data-q="' + it.quantity + '" aria-label="Diminuer la quantité">' + ICON.minus + '</button><span>' + it.quantity + '</span><button type="button" data-inc="' + (i + 1) + '" data-q="' + it.quantity + '" aria-label="Augmenter la quantité">' + ICON.plus + '</button></div></div></li>';
      }).join('') + '</ul>';
      var up = Cart.upsell;
      if (up && !d.items.some(function (it) { return it.variant_id === up.id; })) {
        html += '<div class="dl-up">' + (up.image ? '<img src="' + esc(up.image) + '" alt="" width="48" height="48">' : '') + '<p>Ajouter : ' + esc(up.title) + '</p>' +
          (up.single ? '<button type="button" class="btn-mini" data-upsell-add="' + up.id + '">+' + money(up.price) + '</button>' : '<a class="btn-mini" href="' + esc(up.url) + '">Choisir</a>') + '</div>';
      }
      body.innerHTML = html;
      $('[data-sub]').textContent = money(d.total_price);
      foot.hidden = false;
    }
  };

  /* ---------------- Boîte d'achat ---------------- */
  function colorKey(opts) {
    return /blanc|white/i.test(opts.join(' ')) ? 'blanc' : 'bleu';
  }
  function initBuybox(box) {
    if (box.__init) return; box.__init = true;
    var variants = JSON.parse($('[data-variants]', box).textContent);
    var idIn = $('[data-variant-id]', box), qtyIn = $('[data-qty-input]', box);
    var tiers = box.dataset.tiers === 'true';
    var off = { 1: 0, 2: (+box.dataset.off2 || 0) / 100, 3: (+box.dataset.off3 || 0) / 100 };
    var qty = 1, tierQ = 1;
    var btn = $('.js-buy-btn', box), btnText = $('[data-btn-text]', box);
    var opts = function (v) { return [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }); };
    var selected = function () { return $$('[data-option]', box).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; }); };
    var current = function () {
      var s = selected(); if (!s.length) return variants[0];
      return variants.filter(function (v) { var o = opts(v); return s.every(function (x, i) { return o[i] === x; }); })[0] || null;
    };
    function update() {
      var v = current();
      if (!v) { btn.disabled = true; btnText.textContent = 'Indisponible'; return; }
      idIn.value = v.id;
      $$('[data-option]', box).forEach(function (f) {
        var c = $('input:checked', f), l = $('[data-opt-label]', f);
        if (c && l) l.textContent = '— ' + c.value;
      });
      var unit = v.price, cmp = v.compare_at_price > v.price ? v.compare_at_price : 0;
      var q = tiers ? tierQ : 1, d = tiers ? off[tierQ] : 0;
      // même arrondi que Shopify : remise calculée par article, arrondie au centime inférieur
      var tierTotal = function (k) { return k * (unit - Math.floor(unit * off[k] + 1e-6)); };
      var total = tiers ? tierTotal(q) : unit * q;
      var was = cmp ? cmp * q : (total < unit * q ? unit * q : 0);
      $('[data-price]', box).textContent = money(total);
      var cEl = $('[data-compare]', box), oEl = $('[data-off]', box);
      var showWas = was > total;
      cEl.hidden = oEl.hidden = !showWas;
      if (showWas) { cEl.textContent = money(was); oEl.textContent = '-' + Math.round((1 - total / was) * 100) + ' %'; }
      $$('[data-tier-price]', box).forEach(function (el) {
        var k = +el.getAttribute('data-tier-price');
        el.textContent = money(tierTotal(k));
      });
      qtyIn.value = tiers ? tierQ : qty;
      var qv = $('[data-qty-val]', box); if (qv) qv.textContent = qty;
      btn.disabled = !v.available;
      btnText.textContent = v.available ? btn.getAttribute('data-label') : 'Épuisé';
      if (box.hasAttribute('data-sync-url') && variants.length > 1 && window.history.replaceState) {
        window.history.replaceState(null, '', location.pathname + '?variant=' + v.id);
      }
      document.dispatchEvent(new CustomEvent('buybox:change', {
        detail: { box: box, variant: v, colorKey: colorKey(opts(v)), mediaId: v.featured_media && v.featured_media.id }
      }));
    }
    box.addEventListener('change', function (e) {
      var n = e.target.name || '';
      if (n.indexOf('option-') === 0) update();
      if (n.indexOf('tier-') === 0) { tierQ = +e.target.value; update(); }
    });
    var dec = $('[data-qty-dec]', box), inc = $('[data-qty-inc]', box);
    if (dec) dec.addEventListener('click', function () { qty = Math.max(1, qty - 1); update(); });
    if (inc) inc.addEventListener('click', function () { qty = Math.min(20, qty + 1); update(); });
    update();
  }

  /* ---------------- Galerie du hero ---------------- */
  function initHero(root) {
    var g = $('[data-hero-gallery]', root); if (!g || g.__init) return; g.__init = true;
    var st = { color: 'bleu', view: 'seal' };
    var tabs = $$('[data-view-btn]', g), cap = $('[data-g-caption]', g), frame = $('[data-g-frame]', g);
    function paint() {
      $$('.g-slide', g).forEach(function (s) { s.classList.toggle('is-on', s.dataset.color === st.color && s.dataset.view === st.view); });
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-view-btn') === st.view); });
      if (cap) cap.textContent = st.view === 'seal' ? 'Scellé en 1 seconde' : 'Se fixe sur tout frigo';
      var vd = $('video', g); if (vd && vd.classList.contains('is-on') && vd.play) { var p = vd.play(); if (p && p.catch) p.catch(function () {}); }
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { st.view = t.getAttribute('data-view-btn'); paint(); }); });
    if (window.matchMedia && matchMedia('(hover: hover)').matches) {
      frame.addEventListener('mouseenter', function () { st.view = 'fridge'; paint(); });
      frame.addEventListener('mouseleave', function () { st.view = 'seal'; paint(); });
    }
    document.addEventListener('buybox:change', function (e) {
      if (root.contains(e.detail.box)) { st.color = e.detail.colorKey; paint(); }
    });
    paint();
  }

  /* ---------------- Galerie produit ---------------- */
  function initPG(g) {
    if (g.__init) return; g.__init = true;
    var slides = $$('.pg-slide', g), thumbs = $$('[data-thumb]', g);
    function show(id) {
      var found = false;
      slides.forEach(function (s) { var on = s.getAttribute('data-media-id') === String(id); s.classList.toggle('is-on', on); found = found || on; });
      thumbs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-thumb') === String(id)); });
      return found;
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-thumb')); }); });
    document.addEventListener('buybox:change', function (e) {
      if (e.detail.mediaId && g.closest('.pdp') && g.closest('.pdp').contains(e.detail.box)) show(e.detail.mediaId);
    });
  }

  /* ---------------- Comment ça marche ---------------- */
  function initHow(root) {
    if (root.__init) return; root.__init = true;
    var steps = $$('[data-step]', root), panels = $$('[data-panel]', root), label = $('[data-step-label]', root), timer;
    function go(i) {
      steps.forEach(function (s, k) {
        var on = k === i;
        s.classList.remove('is-on');
        if (on) { void s.offsetWidth; s.classList.add('is-on'); }
        s.setAttribute('aria-pressed', on);
      });
      panels.forEach(function (p, k) { p.classList.toggle('is-on', k === i); p.setAttribute('aria-hidden', k !== i); });
      if (label) label.textContent = 'Étape 0' + (i + 1);
      clearTimeout(timer);
      if (!reduceMotion) timer = setTimeout(function () { go((i + 1) % steps.length); }, 5200);
    }
    steps.forEach(function (s, k) { s.addEventListener('click', function () { go(k); }); });
    go(0);
  }

  /* ---------------- Avant / après ---------------- */
  function initBA(f) {
    if (f.__init) return; f.__init = true;
    var r = $('input', f);
    r.addEventListener('input', function () { f.style.setProperty('--pos', r.value + '%'); });
  }

  /* ---------------- Barre d'achat mobile ---------------- */
  function initSticky(bar) {
    if (bar.__init) return; bar.__init = true;
    var scope = bar.closest('.shopify-section') || document;
    var target = $('.js-buy-btn', scope); if (!target || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    new IntersectionObserver(function (es) {
      var e = es[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(target);
    $('[data-sticky-add]', bar).addEventListener('click', function () { target.click(); });
    document.addEventListener('buybox:change', function (e) {
      var p = $('[data-sticky-price]', bar);
      if (p && scope.contains(e.detail.box)) p.textContent = $('[data-price]', e.detail.box).textContent;
    });
  }

  /* ---------------- Apparition au scroll ---------------- */
  function initReveal(root) {
    var els = $$('.reveal:not(.in)', root);
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initAll(root) {
    $$('[data-buybox]', root).forEach(initBuybox);
    if (root.matches && root.matches('[data-hero]')) initHero(root);
    $$('[data-hero]', root).forEach(initHero);
    $$('[data-pgallery]', root).forEach(initPG);
    $$('[data-how]', root).forEach(initHow);
    $$('[data-ba]', root).forEach(initBA);
    $$('[data-sticky]', root).forEach(initSticky);
    initReveal(root);
  }

  /* ---------------- Événements globaux ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest('[data-cart-open]');
    if (open && location.pathname.indexOf(cfg.routes.cart) !== 0 && $('[data-drawer]')) {
      e.preventDefault(); Cart.open(); Cart.refresh(); return;
    }
    if (t.closest('[data-drawer-close]')) { Cart.close(); return; }
    var dec = t.closest('[data-dec]'), inc = t.closest('[data-inc]'), up = t.closest('[data-upsell-add]');
    if (dec) { Cart.change(+dec.getAttribute('data-dec'), Math.max(0, +dec.getAttribute('data-q') - 1)); return; }
    if (inc) { Cart.change(+inc.getAttribute('data-inc'), +inc.getAttribute('data-q') + 1); return; }
    if (up) { up.disabled = true; Cart.addId(+up.getAttribute('data-upsell-add')); return; }
    var mt = t.closest('[data-menu-toggle]');
    if (mt) {
      var nav = $('[data-mnav]'), isOpen = mt.getAttribute('aria-expanded') === 'true';
      mt.setAttribute('aria-expanded', !isOpen); nav.hidden = isOpen;
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ajax-add]') || !$('[data-drawer]')) return;
    e.preventDefault();
    var btn = $('button[type="submit"]', form), err = $('[data-form-error]', form.closest('.buybox') || form);
    if (btn) btn.disabled = true;
    if (err) err.hidden = true;
    Cart.add(form).catch(function (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; } else { window.alert(ex.message); }
    }).then(function () { if (btn) btn.disabled = false; });
  });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  Cart.init();
  initAll(document);
})();
